/// <reference path="../windowbroadcastmessage.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="globalsettingsservice.ts" />

module App.Common.Services {
	'use strict';

	export class WindowBroadcastService {

		public static $inject = [
			'$window',
			'$rootScope',
			'$localStorage',
			'$sessionStorage',
			'app.common.services.logService',
			'app.common.services.globalSettingsService'];
		constructor(
			private $window: angular.IWindowService,
			private $rootScope: angular.IRootScopeService,
			private $localStorage: Common.ILocalStorage,
			private $sessionStorage: Common.ISessionStorage,
			private logger: Services.LogService,
			private globalSettings: Services.GlobalSettingsService) {

			var window = angular.element(this.$window);
			window.on('storage', this.receive);

			$rootScope.$on('$destroy', () => {
				window.off('storage', this.receive);
			});
		}

		public send(eventName: string, data: any = null) {
			this.logger.debug(`Sending ${eventName} message`);
			this.$localStorage.windowBroadcast = new WindowBroadcastMessage(
				this.$sessionStorage.windowId,
				eventName,
				data
			);
		}

		public receive = (event: JQueryEventObject) => {
			var typedEvent = (event.originalEvent || event as {}) as StorageEvent; //Work around the inadequate JQueryEventObject interface

			//Only respond to storage events for the correct storage key
			if (typedEvent.key === 'hilo-windowBroadcast') {
				var message = angular.fromJson(typedEvent.newValue || '') as WindowBroadcastMessage;
				if (message.sourceWindowId !== this.$sessionStorage.windowId) { //Only respond to events created by other windows
					this.logger.debug(`Received ${message.eventName} event from another window`);
					this.$rootScope.$broadcast.apply(message.eventName, message.data);
				}
			}
		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.windowBroadcastService', WindowBroadcastService);
}